import { Badge } from "@chakra-ui/react-v3";
import { BaseTableLayout, ColumnDef } from "../../components/base-table-layout";
import { CodingBadge } from "../../components/coding-badge";
import { HighlightedText } from "../../components/highlighted-text";
import { SuspectRowData } from "./suspect-rows";

const ICD_10_SYSTEM = "http://hl7.org/fhir/sid/icd-10-cm";

export type SuspectTableProps = {
  rows: SuspectRowData[];
  displayName?: string;
  onRowClick: (row: SuspectRowData) => void;
  filterQuery: string;
  isRowViewed?: (row: SuspectRowData) => boolean;
};

export function SuspectTable({
  rows,
  displayName,
  onRowClick,
  filterQuery,
  isRowViewed,
}: SuspectTableProps) {
  if (!rows.length) return null;

  const columns: ColumnDef<SuspectRowData>[] = [
    { key: "conditionName", header: "Condition" },
    {
      key: "icd10Code",
      header: "Code",
      isHiddenOnSmallScreen: true,
      render: (row, searchQuery) =>
        row.icd10Code ? (
          <CodingBadge
            coding={{ system: ICD_10_SYSTEM, code: row.icd10Code }}
            searchQuery={searchQuery}
          />
        ) : null,
    },
    {
      key: "detectionLabel",
      header: "Suspect Group",
      render: (row, searchQuery) => (
        <Badge
          colorPalette="blue"
          variant="subtle"
          size="sm"
          cursor="help"
          textDecoration="underline"
          textDecorationStyle="dotted"
          title={row.detectionLogic}
        >
          <HighlightedText text={row.detectionLabel} searchQuery={searchQuery} />
        </Badge>
      ),
    },
  ];

  return (
    <BaseTableLayout
      title={displayName ?? "Suspects"}
      rows={rows}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={onRowClick}
      isRowViewed={isRowViewed}
    />
  );
}
